<template>
  <my_public_index
    :module="module"
    :column="column"
    :moduleIndex="module_index"
  >
    <template #content>
      <empty-tips
        :empty_tips_show="(listArr.url === '' && listArr.type === 'url' && !listArr.isHttpUrl) || (listArr.code === '' && listArr.type === 'code' && !listArr.isHttpCode)"
        @handleClick="tipsClick"
        type="empty_tips"
      />
      <div
        v-show="listArr.url !== '' && listArr.type === 'url' && !listArr.isHttpUrl"
        :style="{height: `${pc_widgets_infor.height}px`}"
      >
        <iframe
          :style="{
          width: `${pc_widgets_infor.width}%`,
          height: `${pc_widgets_infor.height}px`
        }"
          class="pointer_events_none"
          :src="listArr.url"
        ></iframe>
      </div>
      <div
        v-html="listArr.code"
        v-show="listArr.code !== '' && listArr.type === 'code' && !listArr.isHttpCode"
        :style="{height: vHtmlH}"
      ></div>
      <empty-tips
        :tips_show="(listArr.type === 'url' && listArr.isHttpUrl) || (listArr.type === 'code' && listArr.isHttpCode)"
        @handleClick="tipsClick"
        type="tips"
      />
    </template>
  </my_public_index>
</template>

<script>
import i18n from '../../language/index'

import { emptyTips } from '@/widgets/basic_plugin_code/components'

export default {
  name: "basic_embed_page",
  props: {
    module: {
      type: Object,
      default: null
    },
    column: {
      type: Object,
      default: null
    },
    module_index: {
      type: Number,
      default: 0
    }
  },
  components: { emptyTips },
  data () { return {} },
  computed: {
    pc_widgets_infor () {
      return this.module.data.pc_widgets_infor;
    },
    listArr () {
      return this.module.data.listArr;
    },
    vHtmlH () {
      const code = this.listArr.code
      const h = code.match(/\bheight\b\s*=\s*[\'\"]?([^\'\"]*)[\'\"]?/i);
      if (h && h[1]) {
        const v = h[1]
        if (v.includes('%') || v.includes('px')) return v;
        else return `${v}px`
      }
    }
  },
  methods: {
    tipsClick (type) {
      switch (type) {
        case 'empty_tips':
          this.templet.changeStyle(this.module, 'style');
          break
        case 'tips':
          let { href } = window.location;
          href = href.replace(/https/, "http");
          window.open(href, "_self");
          break
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/css/commonly.scss";
</style>

<style>
.basic_embed_page iframe {
  border: 0;
  pointer-events: none;
}
</style>



// WEBPACK FOOTER //
// src/widgets/basic_embed_page/index.vue